





















import VueOptions from '@utils/VueOptions'
import Back from '@modules/ui/buttons/Back'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import SponsorOrgSelector from '@superUI/Selectors/SponsorOrgSelector'
import BrandOpportunityForm from '@superUI/Forms/BrandOpportunityForm'
import RequestButton from '@components/RequestButton'

settings =
  name: "BrandOpportunityCreate"
  components: { Back, SuperContainerView, SponsorOrgSelector, BrandOpportunityForm, RequestButton }
  resources:
    newBrandOpportunity:
      resourceName: 'brand_opportunity'
      slug: 'brand_opportunities/new'
  vue:
    data: ->
      selectedSubSponsorId: null
      selectedTopSponsorId: null
      selectedSponsorId: null

    methods:
      onSave: (item) -> @$router.push({ name: 'BrandOpportunityShowPage', params: { opportunityId: item.id } })

      hiSave: ->
        @prime.newBrandOpportunity.sponsor_id = @selectedSponsorId
        @saveItem('prime.newBrandOpportunity')

      hiBack: ->
        if @selectedSponsorId
          @selectedSubSponsorId = null
          @selectedSponsorId = null
        else
          @selectedSubSponsorId = null
          @selectedTopSponsorId = null

      hiSponsorSelected: (selectedSponsor) ->
        @selectedSponsorId = selectedSponsor.id

export default VueOptions.vue settings
